import usePersonalizedRecommendation from 'components/shared/useEffect/usePersonalizedRecommendation'
import useSimilarProduct from 'components/shared/useEffect/useSimilarProduct'
import useUpsells from 'components/shared/useEffect/useUpsells'

const DynamicComponentData = {
  personalization: {
    dataFetchingMethod: usePersonalizedRecommendation,
    id: 'just-for-you',
    title: {
      key: 'JUST_FOR_YOU_TITLE',
      value: 'Just For You',
    },
  },
  similar: {
    dataFetchingMethod: useSimilarProduct,
    id: 'similar-products',
    title: {
      key: 'SIMILAR_PRODUCTS_TITLE',
      value: 'similar products',
    },
  },
  upSell: {
    dataFetchingMethod: useUpsells,
    id: 'people-also-bought',
    title: {
      key: 'ALSO_BOUGHT_TITLE',
      value: 'People Also Bought',
    },
  },
}

const MAX_RELATED_PRODUCT_NUM = {
  mobile: 6,
  desktop: 6,
}

const IS_GUEST_MODE = true

export default DynamicComponentData

export { IS_GUEST_MODE, MAX_RELATED_PRODUCT_NUM }
